export interface BTMModel {
  id: string;
  name: string;
  features: string[];
  maxLimit: number;
}

export const BTM_MODELS = {
  MODEL_V: {
    id: 'model-v',
    name: 'Model V',
    features: ['High Volume', 'Touch Screen', 'Bill Validator', 'Receipt Printer'],
    maxLimit: 10000
  },
  UNIVERSAL: {
    id: 'universal',
    name: 'Universal Model',
    features: ['Multi-Currency', 'Touch Screen', 'Bill Validator'],
    maxLimit: 5000
  },
  MINI: {
    id: 'mini',
    name: 'Mini Model',
    features: ['Compact Size', 'Basic Interface', 'Bill Validator'],
    maxLimit: 3000
  }
} as const;